import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { WashingtonPin } from "../../../app-constants";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "What services are covered under your custom software development?",
    answer: `<p>We offer full-cycle custom software development, including conducting a thorough business analysis, creating UI/UX design, developing your business tool, performing rigorous QA testing, and launching the software per client requirement and preference.</p>`,
  },
  {
    question:
      "What technologies and languages do you use for software development?",
    answer: `<p>The programming languages we use for development include Java, Kotlin, Swift, and Objective-C. The databases we use include Firebase, SQLite, CoreData, and Realm.</p>`,
  },
  {
    question: "I have an idea; what do I do now?",
    answer: ` <p>We would discuss the project with you, conduct a thorough business analysis to validate the idea’s market potential and feasibility, and then test the concept through MVP development. You can hire an Android app developer to inspect your app idea and proceed with MVP development to gather valuable insights.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col xs={12} md={12} lg={8} xl={7} xxl={7} className="services_faqs">
            <FaqComponents faqs={faqs} />
          </Col>

          <Col xs={12} md={12} lg={4} xl={4} xxl={4} className="offset-xl-1">
            <div className="map_loc">{WashingtonPin}</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
